module.exports = __webpack_public_path__ + "media/images/category/rank2-94744f8dc2b064067d6f7915671d6b59.gif";